import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { AssetStatusTagsProps } from "models/propTypes/holdingRegisterPropTypes";
//#endregion
//#region components
import { Tags } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const AssetStatusTags: React.FC<AssetStatusTagsProps> = (props) => {
  const getLabelClass = (status: boolean) => {
    if (status) return cssExports.greenTag;
    return cssExports.grayTag;
  };

  const getStateText = (state: boolean) => {
    if (state) return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Yes);
    return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.No);
  };

  return <Tags tags={[getStateText(props.status)]} className={getLabelClass(props.status)} />;
};

export default AssetStatusTags;
